import React, { useContext } from 'react';
import CompanySectionLayout from '../../../../component/B2B/CompanySectionLayout';
import { SidebarContext } from '../../../../context/SidebarContext';
import { getLocalStorageItem } from '../../../../utils/helper';

/** Company panel → Meditation Sounds: practice dashboard and the employee list. */
const CompanyMeditationLayout = ({ children }) => {
  const { isB2BFansMode } = useContext(SidebarContext);
  const userData = JSON.parse(getLocalStorageItem('userData') || '{}');
  const slug = userData?.slug;

  const population = isB2BFansMode ? 'members' : 'employees';

  const pages = [
    {
      label: 'Meditation Dashboard',
      path: `/${slug}/meditation`,
      description: 'Plays, listening time and which meditations carry the volume'
    },
    {
      label: isB2BFansMode ? 'Members' : 'Employees',
      path: `/${slug}/meditation/users`,
      description: `Per-${population.replace(/s$/, '')} meditation records`
    }
  ];

  return (
    <CompanySectionLayout
      title="Meditation Sounds"
      subtitle={`What your ${population} meditate to, and how much of it.`}
      pages={pages}
      reportFeatureKey="meditation"
    >
      {children}
    </CompanySectionLayout>
  );
};

export default CompanyMeditationLayout;
